export default "__VITE_ASSET__CdtCl5jP__ 160w, __VITE_ASSET__ukZF3Dk5__ 320w, __VITE_ASSET__3ZiZ7lFG__ 480w, __VITE_ASSET__DsPju8$o__ 640w";